import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DashboardsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Dashboards",
    children: isCanvas ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("rect", {
        width: "12.83",
        height: "14.94",
        x: "2",
        y: "14.16",
        rx: "1.63",
        ry: "1.63"
      }), /*#__PURE__*/_jsx("rect", {
        width: "12.83",
        height: "8.97",
        x: "2",
        y: "2.9",
        rx: "1.27",
        ry: "1.27"
      }), /*#__PURE__*/_jsx("rect", {
        width: "12.83",
        height: "14.94",
        x: "17.17",
        y: "2.9",
        rx: "1.63",
        ry: "1.63"
      }), /*#__PURE__*/_jsx("rect", {
        width: "12.83",
        height: "8.97",
        x: "17.17",
        y: "20.05",
        rx: "1.27",
        ry: "1.27"
      })]
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M13.29 11H3c-.63 0-1.14-.51-1.14-1.14V3c0-.63.51-1.14 1.14-1.14h10.29c.63 0 1.14.51 1.14 1.14v6.86c0 .63-.51 1.14-1.14 1.14M4.14 8.71h8V4.14h-8zM13.29 29.29H3c-.63 0-1.14-.51-1.14-1.14V14.44c0-.63.51-1.14 1.14-1.14h10.29c.63 0 1.14.51 1.14 1.14v13.71c0 .63-.51 1.14-1.14 1.14M4.14 27h8V15.57h-8zM28.14 17.86H17.85c-.63 0-1.14-.51-1.14-1.14V3c0-.63.51-1.14 1.14-1.14h10.29c.63 0 1.14.51 1.14 1.14v13.71c0 .63-.51 1.14-1.14 1.14ZM19 15.57h8V4.14h-8zM28.14 29.29H17.85c-.63 0-1.14-.51-1.14-1.14v-6.86c0-.63.51-1.14 1.14-1.14h10.29c.63 0 1.14.51 1.14 1.14v6.86c0 .63-.51 1.14-1.14 1.14M19 27h8v-4.57h-8z"
      })
    })
  }));
};
DashboardsIcon.displayName = 'DashboardsIcon';